import { state, setUser } from '../state';
import { setToken } from '../api';
import { navigate, refresh, scrollToSection } from '../lib/router';
import { escapeHtml, initials } from '../lib/utils';
import { openChangePasswordModal } from '../components/changePasswordModal';

let detachUserMenu: (() => void) | null = null;

export function renderHeader(el: HTMLElement): void {
  const user = state.user;

  // Remove listeners from the previous render (header is re-rendered on every
  // route change, but the header element itself is reused).
  detachUserMenu?.();
  detachUserMenu = null;

  el.innerHTML = `
    <div class="nav container">
      <a class="brand" href="#/">
        <span class="brand-logo">F</span> FlowBoard
      </a>
      <nav class="nav-links">
        ${
          user
            ? `
          <a class="nav-link" href="#/public">Public projects</a>
          <a class="nav-link" href="#/projects">My Projects</a>
          <div class="nav-user">
            <button class="nav-user-trigger" id="user-menu-trigger" aria-haspopup="menu" aria-expanded="false">
              <span class="avatar">${initials(user.name)}</span>
              <span class="nav-username">${escapeHtml(user.name)}</span>
              <span class="chevron" aria-hidden="true">▾</span>
            </button>
            <div class="user-menu" id="user-menu" role="menu" hidden>
              <button class="user-menu-item" id="change-password-btn" role="menuitem">Change password</button>
              <button class="user-menu-item user-menu-item-danger" id="logout-btn" role="menuitem">Log out</button>
            </div>
          </div>
        `
            : `
          <a class="nav-link" href="#/public">Public projects</a>
          <button class="nav-link" data-scroll="features">Features</button>
          <button class="nav-link" data-scroll="how-it-works">How it works</button>
          <a class="btn btn-ghost" href="#/login">Log in</a>
          <a class="btn btn-primary" href="#/signup">Sign up free</a>
        `
        }
      </nav>
    </div>
  `;

  el.querySelectorAll<HTMLElement>('[data-scroll]').forEach((btn) => {
    btn.addEventListener('click', () => scrollToSection(btn.dataset.scroll!));
  });

  const trigger = el.querySelector<HTMLButtonElement>('#user-menu-trigger');
  const menu = el.querySelector<HTMLElement>('#user-menu');

  if (trigger && menu) {
    const close = () => {
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    };

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      const willOpen = menu.hidden;
      menu.hidden = !willOpen;
      trigger.setAttribute('aria-expanded', String(willOpen));
    });

    const onClickOutside = (e: MouseEvent) => {
      if (!menu.hidden && !el.contains(e.target as Node)) close();
    };
    const onKeydown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && !menu.hidden) close();
    };

    document.addEventListener('click', onClickOutside);
    document.addEventListener('keydown', onKeydown);
    detachUserMenu = () => {
      document.removeEventListener('click', onClickOutside);
      document.removeEventListener('keydown', onKeydown);
    };

    el.querySelector('#change-password-btn')?.addEventListener('click', () => {
      close();
      openChangePasswordModal();
    });

    el.querySelector('#logout-btn')?.addEventListener('click', () => {
      setToken(null);
      setUser(null);
      navigate('/');
      refresh();
    });
  }
}
